import { render, staticRenderFns } from "./townCultural.vue?vue&type=template&id=3e054854&scoped=true&"
import script from "./townCultural.vue?vue&type=script&lang=js&"
export * from "./townCultural.vue?vue&type=script&lang=js&"
import style0 from "./townCultural.vue?vue&type=style&index=0&id=3e054854&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e054854",
  null
  
)

export default component.exports